import { Link } from "react-router-dom";

// Routes declared in spec §6.1 that are implemented in later phases:
//   /exercises -> Phase 5, /admin -> Phase 5.
export default function PlaceholderPage({ title, phase }: { title: string; phase: string }) {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 bg-slate-100 text-slate-600">
      <h1 className="text-2xl font-semibold text-slate-800">{title}</h1>
      <p>Coming in {phase}.</p>
      <Link to="/" className="text-sky-600 underline">
        Back to the simulator
      </Link>
    </div>
  );
}
